<template>
  <div>
    <div class="bg-over">
    </div>
    <div>
      <HeadBar class="header-class" v-if="isReload" ></HeadBar>
      <AppMain class="app-class"  v-if="isReload" :style="{'height':'calc('+(height - 112)+'px)'}"></AppMain>
<!--      <FootBar class="footer-class"></FootBar>-->
    </div>
  </div>
</template>

<script>
import {HeadBar, FootBar, AppMain} from './components'

export default {
  name: "layout",
  components: {
    HeadBar, FootBar, AppMain
  },
  data() {
    return {
      width: '1920',
      height: '1080',
      padding: '0',
      isFull: true,
      style: {
        width: "1440px",
        height: "909px",
        transform: "scale(1) translate(-50%, -50%)",
        padding: 0,
      },
      isReload:false //防止手动刷新网页，导致重复调用接口两次
    }
  },
  provide() {
    return {
      msg: "未刷新",
      reload: this.reload,
    };
  },
  mounted() {
    this.height = window.innerHeight
    console.log('height',this.height)
    this.style.height = window.innerHeight
    this.setScale();
    window.onresize = this.Debounce(this.setScale, 1000);
    this.getUserInfo()

  },
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      // 深度观察监听
      deep: true,
      handler(to, from) {

      },
    }
  },
  methods: {
    async reload() {
      this.isReload = false;
      await this.$nextTick();
      this.isReload = true;
    },
    getUserInfo() {
      this.$store.dispatch('GetUserInfo','yqfx').then(v => {
        this.reload()
      })
    },
    Debounce: (fn, t) => {
      const delay = t || 500;
      let timer;
      return function () {
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // // 获取放大缩小比例
    getScale() {
      const w = window.innerWidth / this.width;
      const h = window.innerHeight / this.height;
      if (this.isFull) {
        return [w, h];
      }
      return w < h ? w : h;
    },
    // // 设置比例
    setScale() {
      this.height = window.innerHeight
    },
  }
}
</script>

<style scoped>
.bg-over {
  height: 100vh;
  width: 100vw;
  background: url(../assets/images/common/bg-over.png) center/cover;
  position: fixed;
  z-index: -1;
}

.app-class {
  width: 100%;
  display: grid;
}

.footer-class {
  height: 20px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layoutPark/layout.vue